import gql from "graphql-tag";
export const GET_DASHBOARD_ITEMS = gql`
  query GetDashboardItems {
    dashboardItems {
      id
      layout
      vizState
      name
      # shortTitle  /// this is not part of the item propertly shortTitle should be part of the retreived data property
    }
  }
`;
export const GET_DASHBOARD_ITEM = gql`
  query GetDashboardItem($id: String!) {
    dashboardItem(id: $id) {
      id
      layout
      vizState
      name
      # shortTitle
    }
  }
`;
